import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InterhellNavigation = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    political: 0,
    conspiratorial: 0,
    troll_hole: 0,
    spam: 0,
    total_moderated: 0
  });

  useEffect(() => {
    fetchModerationStats();
  }, []);

  const fetchModerationStats = async () => {
    try {
      const response = await axios.get(`${API}/moderation/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching moderation stats:', error);
    }
  };

  const circles = [
    {
      key: 'political',
      path: '/political',
      title: 'Political',
      icon: '🏛️',
      description: 'Divisive political content',
      bgColor: 'from-red-800 to-red-900',
      hoverColor: 'hover:from-red-700 hover:to-red-800',
      textColor: 'text-red-100',
      count: stats.political
    },
    {
      key: 'conspiratorial',
      path: '/conspiratorial',
      title: 'Conspiratorial',
      icon: '🔍',
      description: 'Conspiracy theories',
      bgColor: 'from-purple-800 to-purple-900',
      hoverColor: 'hover:from-purple-700 hover:to-purple-800',
      textColor: 'text-purple-100',
      count: stats.conspiratorial
    },
    {
      key: 'troll_hole',
      path: '/troll-hole',
      title: 'Troll Hole',
      icon: '🕳️',
      description: 'Trolling & harassment',
      bgColor: 'from-gray-800 to-gray-900',
      hoverColor: 'hover:from-gray-700 hover:to-gray-800',
      textColor: 'text-gray-100',
      count: stats.troll_hole
    },
    {
      key: 'spam',
      path: '/spam',
      title: 'Spam',
      icon: '🍖',
      description: 'Spam & unwanted content',
      bgColor: 'from-yellow-800 to-orange-900',
      hoverColor: 'hover:from-yellow-700 hover:to-orange-800',
      textColor: 'text-yellow-100',
      count: stats.spam
    }
  ];

  return (
    <div className="bg-gradient-to-br from-gray-900 to-black rounded-xl shadow-2xl p-6 border border-gray-700">
      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-red-400 mb-2">
          ⚡ Four Circles of Interhell ⚡
        </h3>
        <p className="text-gray-300 text-sm">
          Negative content dungeons • AI training signals
        </p>
        <div className="text-gray-400 text-xs mt-2">
          Total moderated: {stats.total_moderated}
        </div>
      </div>

      <div className="space-y-3">
        {circles.map((circle) => (
          <button
            key={circle.key}
            onClick={() => navigate(circle.path)}
            className={`w-full p-4 bg-gradient-to-r ${circle.bgColor} ${circle.hoverColor} rounded-lg transition-all duration-300 transform hover:scale-105 border border-gray-600 hover:border-gray-500`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <span className="text-2xl">{circle.icon}</span>
                <div className="text-left">
                  <div className={`font-bold ${circle.textColor} text-sm`}>
                    {circle.title}
                  </div>
                  <div className="text-gray-400 text-xs">
                    {circle.description}
                  </div>
                </div>
              </div>
              <div className={`${circle.textColor} font-bold text-lg bg-black/30 px-2 py-1 rounded-full min-w-[32px] text-center`}>
                {circle.count}
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="mt-4 text-center">
        <div className="text-gray-500 text-xs border-t border-gray-700 pt-3">
          🤖 These serve as negative prompts for AI systems
        </div>
      </div>
    </div>
  );
};

export default InterhellNavigation;